import { ChangeDetectionStrategy, Component, computed, effect, inject, input } from '@angular/core';
import { ContractWidget } from '../../../../models';
import { Contract } from '../../../../models/contract';
import { CtrlIconsModule } from '@co-3/ctrl-ui/icons';
import { SharedModule } from '../../../../shared/shared.module';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { uniqueId } from '@co-3/ctrl-ui/common';
import { PortalCollapsibleComponent } from '../../../../customer-portal/components/portal-collapsible/portal-collapsible.component';
import { PortalWidgetDetailsComponent } from '../../../../customer-portal/components/portal-widget-details/portal-widget-details.component';
import { ContractsService } from 'app/customer-portal';

@Component({
    selector: 'app-insured-bike-widget',
    imports: [CtrlIconsModule, SharedModule, PortalCollapsibleComponent, PortalWidgetDetailsComponent],
    templateUrl: './insured-bike-widget.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InsuredBikeWidgetComponent implements ContractWidget {
    public contract = input.required<Contract>();

    private contractsService = inject(ContractsService);

    public constructor() {
        this.formGroup.markAllAsTouched();
        effect(() => {
            const frameNumber = this.insuredBike().ObjectDetail;
            if (frameNumber === '' || frameNumber == null) {
                return;
            }
            this.formGroup.get('frameNumber').setValue(frameNumber);
        });
    }

    protected insuredBike = computed(() => this.contract().objectPool[0]);

    protected frameNumber = computed(() => this.insuredBike().ObjectDetail);

    protected title = computed(() => this.insuredBike().ObjectDescription);

    protected price = computed(() => this.insuredBike().ObjectValue);

    protected isComplete = computed(() => (this.frameNumber() ?? '').length >= 3);

    protected formGroup = new FormGroup({
        frameNumber: new FormControl('', { validators: [Validators.required, Validators.minLength(3)] }),
    });

    protected showError(errorCode?: 'required' | 'minlength'): boolean {
        const control = this.formGroup.get('frameNumber');
        const hasError = control.invalid;
        const touched = control.touched;

        if (errorCode == null) {
            return touched && hasError;
        } else {
            return touched && control.hasError(errorCode);
        }
    }

    protected onSubmit(): void {
        if (this.formGroup.invalid) {
            return;
        }

        this.contractsService
            .updateInsuredObjects(this.contract().id, [
                { ...this.insuredBike(), ObjectDetail: this.formGroup.controls.frameNumber.value },
            ])
            .subscribe();
    }

    protected errorId = uniqueId('frame-number-error');
}
